import {useRef} from 'react'

type TimeoutResponse = [
  (callback?: () => void) => void,
  () => void,
  React.MutableRefObject<NodeJS.Timeout | undefined>
]

function useTimeout(time: number, defaultCallback?: Function): TimeoutResponse {
  const ref = useRef<NodeJS.Timeout>()

  function start(callback?: Function) {
    clear()

    const fn = callback || defaultCallback
    if (!fn) throw new Error('useTimeout started without a callback')

    setTimeout(fn, time)
  }

  function clear() {
    const timeout = ref.current
    if (timeout) window.clearTimeout(timeout)
  }

  return [start, clear, ref]
}

export default useTimeout
